module.exports = __webpack_public_path__ + "static/media/sub-16.d2e7e0cc.jpg";